export default __webpack_public_path__ + "static/media/under_midashi_pc.c8104495.jpg";